import {EventEmitter, Injectable, Output} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor() { }

  @Output() itemClicked: EventEmitter<boolean> = new EventEmitter<boolean>()

}
